import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-customer-base',
    templateUrl: './customer-base.component.html',
    styleUrls: ['./customer-base.component.sass'],
    standalone: false
})
export class CustomerBaseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
